import { render } from "./CZNewUser.vue?vue&type=template&id=64354753&scoped=true"
import script from "./CZNewUser.vue?vue&type=script&lang=js"
export * from "./CZNewUser.vue?vue&type=script&lang=js"

import "./CZNewUser.vue?vue&type=style&index=0&id=64354753&scoped=true&lang=css"

import exportComponent from "C:\\Devlop\\C-Zone-v1\\UI_EICPartnership\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64354753"]])

export default __exports__